export const getUrlSearch = () => {
  const searchArr = location.search?.substring(1).split('&');

  const searchJson: { [key: string]: string } = searchArr.reduce((prev: { [key: string]: string }, cur: string) => {
    if (!cur) {
      return prev;
    }
    const [key, value] = cur.split('=');
    let decodeValue = value;
    if (value.includes('%')) {// 如果有 encode 过的参数, 将其 decode
      decodeValue = decodeURI(value);
    }
    return {
      ...prev, [key]: decodeValue
    };
  }, {});

  return searchJson;
};
